export default __webpack_public_path__ + "static/media/meta.99c2ab15.png";